import { render, staticRenderFns } from "./thong-ke-phi-van-chuyen.vue?vue&type=template&id=d1ced44a&"
import script from "./thong-ke-phi-van-chuyen.vue?vue&type=script&lang=js&"
export * from "./thong-ke-phi-van-chuyen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports